import { render } from "./EssentialInfoTable.vue?vue&type=template&id=5b4477ef"
import script from "./EssentialInfoTable.vue?vue&type=script&lang=js"
export * from "./EssentialInfoTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__